import TrackingService from "@services/tracking/tracking.service";
import { TypedAnalyticsEvent } from "@services/tracking/types/analyticsEvent";
import {
    BannerImpressionAemModel,
    BannerImpressionTrackingInfo,
} from "@services/tracking/types/trackingInfo/bannerImpressionTrackingInfo";

import { getPageInfo, getUserInfo } from "./pageImpressionTracker";
import { getEventName, getJsonPayload } from "./utils";

const trackBannerImpression = (element: HTMLElement): void => {
    const aemModel: BannerImpressionAemModel = getJsonPayload(element);

    const event: TypedAnalyticsEvent<BannerImpressionTrackingInfo> = {
        event: getEventName(element),
        payload: {
            eventData: {
                ...aemModel,
            },
            pageInfo: getPageInfo(),
            userInfo: getUserInfo(),
        },
    };

    TrackingService.track(event);
};

export { trackBannerImpression };
